



















export default {
    name: 'currency-symbol',
    props: {
        symbol: {
            type: String,
            required: true,
        },
        color: {
            type: String,
            default: '#002e3c',
        },
        backgroundColor: {
            type: String,
            default: '#fffff',
        },
        borderColor: {
            type: String,
            default: 'transparent',
        },
        // Font Size in REM - Mobile first
        fontSize: {
            type: Array,
            default: () => ['6.5', '9.5'],
            validator(input) {
                return input.length === 2;
            },
        },
    },
};
